<script>
  let height;
</script>

<div class='footer-spacer' style="height: {height}px"></div>
<div class='footer' bind:clientHeight={height}>
  <slot></slot>
</div>

<style>
  .footer-spacer {
    background-color: transparent;
    pointer-events: none;
  }
  .footer {
    text-align: center;
    margin:0;
    color: #999;
    position: fixed;
    left: 0;
    z-index: -2;
    min-height: 20vh;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;  
  }
</style>